"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridHeaderCellWithResizeTrigger = void 0;
const react_1 = __importStar(require("react"));
const GridHeaderCellWithResizeTrigger_styles_1 = require("./GridHeaderCellWithResizeTrigger.styles");
exports.GridHeaderCellWithResizeTrigger = react_1.default.memo(function GridHeaderCellWithResizeTrigger({ children, onDragEnd, onDragStart, onMouseMove, onDoubleClick }) {
    const tearDownRef = (0, react_1.useRef)(null);
    const startMove = (0, react_1.useCallback)((e) => {
        var _a;
        e.stopPropagation();
        e.preventDefault();
        (_a = tearDownRef.current) === null || _a === void 0 ? void 0 : _a.call(tearDownRef);
        if (e.button !== 0) {
            return;
        }
        const { clientX: x, clientY: y } = e;
        onDragStart === null || onDragStart === void 0 ? void 0 : onDragStart({ x, y });
        const stop = (e) => {
            var _a;
            onDragEnd === null || onDragEnd === void 0 ? void 0 : onDragEnd({ x: e.clientX, y: e.clientY });
            (_a = tearDownRef.current) === null || _a === void 0 ? void 0 : _a.call(tearDownRef);
            tearDownRef.current = null;
        };
        const mouseMoveHandler = (e) => {
            requestAnimationFrame(() => {
                var _a, _b, _c, _d;
                try {
                    (_b = (_a = window.getSelection()) === null || _a === void 0 ? void 0 : _a.empty) === null || _b === void 0 ? void 0 : _b.call(_a);
                    (_d = (_c = window.getSelection()) === null || _c === void 0 ? void 0 : _c.removeAllRanges) === null || _d === void 0 ? void 0 : _d.call(_c);
                }
                catch (_e) { }
                onMouseMove === null || onMouseMove === void 0 ? void 0 : onMouseMove({ x: e.clientX, y: e.clientY });
            });
        };
        document.addEventListener('mousemove', mouseMoveHandler);
        document.addEventListener('contextmenu', stop);
        /**
         * We use capture: true as a last resort because when the grid is embedded in a modal,
         * stopPropagation is used inside the <OverlayRoot>,
         * which cannot currently be removed without breaking anything in the product.
         */
        document.addEventListener('mouseup', stop, { capture: true });
        document.addEventListener('mousedown', stop);
        document.addEventListener('mouseleave', stop);
        document.addEventListener('keydown', stop);
        document.addEventListener('blur', stop);
        tearDownRef.current = () => {
            document.removeEventListener('mousemove', mouseMoveHandler);
            document.removeEventListener('contextmenu', stop);
            document.removeEventListener('mousedown', stop);
            document.removeEventListener('mouseup', stop, { capture: true });
            document.removeEventListener('mouseleave', stop);
            document.removeEventListener('keydown', stop);
            document.removeEventListener('blur', stop);
        };
    }, [onDragEnd, onDragStart, onMouseMove]);
    (0, react_1.useEffect)(() => {
        return () => {
            var _a;
            (_a = tearDownRef.current) === null || _a === void 0 ? void 0 : _a.call(tearDownRef);
        };
    }, []);
    return (react_1.default.createElement(GridHeaderCellWithResizeTrigger_styles_1.StyledGridHeaderCellWithResizeTrigger, { "data-selector-id": "grid-core-resize-trigger", className: "vm-GridHeaderCellWithResizeTrigger" },
        children,
        react_1.default.createElement(GridHeaderCellWithResizeTrigger_styles_1.StyledGridHeaderCellWithResizeTriggerControl, { "data-selector-id": "grid-core-resize-trigger-control", onMouseDown: startMove, onDoubleClick: onDoubleClick, className: "vm-GridHeaderCellWithResizeTriggerControl" })));
});
//# sourceMappingURL=GridHeaderCellWithResizeTrigger.js.map